export default {
	homePage: '/',
	trainingApps: '/training-apps',
	userActivation: 'activate-user/:activationToken',
	courses: '/courses',
	tasks: '/courses/:courseSlug/:taskSlug',
	userPasswordRecovery: '/recovery-password/:refreshToken',
	userProfile: {
		root: '/user-profile',
		params: {
			profile: 'profile',
			orders: 'orders',
			trainingEmails: 'training-emails',
		},
	},
	plans: '/plans',
	products: '/services',
	orders: '/orders',
	payment: {
		root: 'payment',
		success: 'payment/success',
		servicePayment: '/service-payment',
		subscriptionPayment: '/subscription-payment',
	},
	contactUs: '/contact',
	cookiesInfo: '/cookies-info',
	privacyPolicy: '/privacy-policy',
	termsAndConditions: '/terms-and-conditions',
	codeEditorPage: '/code/s',
	codeEditorPageSaved: '/code/s/:codeSlug',
	subscription: {
		cancelOrder: 'subscription/cancel',
	},
};
